/**
 *
 * FBAnswersFormsAppointment
 *
 */

import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Button } from 'antd';

// layout components
import ErrorBoundary from 'engine/ErrorBoundary';

// inner communication components 
import {
  FBFormsAnswer,
  FBAppointmentAnswer,
} from 'mobile/components/Communications';


function FBAnswersFormsAppointment({
  data,
  adminAnswer,
  // default props
  actionRequired,
  loading,
  showHeader,
  showAdminAnswer,
  // actions
  onSubmit,
  // default
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-combine-group-answer', className);

  const init = {
    forms: null,
    appointments: null,
    formAnswer: null,
    appointmentAnswer: null,
  };

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  const submitAllForms = useCallback(() => {
    form1.submit();
    form2.submit();
  }, [])

  // On Change form send props to parent form "saveToForm" (if has it)
  const onFormFinishHandle = useCallback(async (formName, { values, forms }) => {
    const formValidate1 = await form1?.validateFields();
    const formValidate2 = await form2?.validateFields();
    if (!!formValidate1 && formValidate2) {
      const formsNames = Object.keys(forms) || [];
      let result = {}

      formsNames?.map(async formName => {
        const form = forms[formName];
        const formValues = form?.getFieldsValue() || {};
        result[formName] = formValues;
      });
      const resultKeys = Object.keys(result) || [];
      const allValid = resultKeys?.filter(el => formsNames?.includes(el))?.length == formsNames?.length;

      !!onSubmit && !!result && !!allValid && onSubmit(result, formsNames);
    }
  }, []);

  return (
    <div className={childClassNames}>
      <ErrorBoundary>
        <Form.Provider onFormFinish={onFormFinishHandle}>
          {!!data?.forms && (
            <FBFormsAnswer
              form={form1}
              loading={loading}
              forms={data?.forms}
              values={data?.formAnswer}
              actionRequired={actionRequired}
              hideActions={true}
            />
          )}
          {!!data?.appointments && (
            <FBAppointmentAnswer
              form={form2}
              loading={loading}
              adminAnswer={adminAnswer}
              appointments={data?.appointments}
              values={data?.appointmentAnswer}
              actionRequired={actionRequired}
              hideActions={true}
            />
          )}

          {(!!actionRequired && (!data?.appointmentAnswer || !data?.formAnswer)) && (
            <div className="actions-wrapper">
              <Button className="btn-previous" onClick={() => {
                form1.resetFields();
                form2.resetFields();
              }}>
                Annuler
              </Button>
              <Button
                className="confirm-btn"
                htmlType="submit"
                onClick={submitAllForms}
              >
                Envoyer
              </Button>
            </div>
          )}
        </Form.Provider>
      </ErrorBoundary>
    </div>
  );
}

FBAnswersFormsAppointment.defaultProps = {
  actionRequired: true,
  showHeader: true,
  showAdminAnswer: false,
  loading: false,
};
FBAnswersFormsAppointment.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onSubmit: PropTypes.func
};

export default FBAnswersFormsAppointment;
